const getStyles = (contextStyles = {}) => {
    return {
        container: {
            display: 'flex',
            flexGrow: 1,
            height: '100%',
            width: '100%',
            boxSizing: 'border-box',
            overflow: 'hidden',
            ...contextStyles.container,
        },
    };
};

export default getStyles;
